const inputsCheckout = [
    {
        text: "Email",
        name: "email",
        type: "email",
        required: true
    },
    {
        text: "Nombre",
        name: "nombre",
        type: "text",
        required: true
    },
    {
        text: "Telefono",
        name: "telefono",
        type: "tel",
        required: true
    },
]
export default inputsCheckout